<template>
  <div class="header flex-box space-between align-center">
    <div class="left" :class='lang == "en" && "mg-t16"'>
      <div class="flex-box">
        <img src="../assets/logo.png" class="logo" />
        <span class="logo-text">{{$t('中国人成骨不全症变异数据库（COIMD）')}}</span>
      </div>
      <div class="logo-arrow"></div>
    </div>
    <div class="flex-box">
      <ul class="flex-box">
        <router-link
          to="/"
          class="herf-item">
          {{
            $t("首页") 
          }}
        </router-link>
        <router-link
          to="/popular"
          class="herf-item">
          {{
            $t('科普')
          }}
        </router-link>
        <!-- <router-link
          to="/consult"
          class="herf-item">
          {{
            lang == 'zh' ? '咨询' : 'consult'
          }}
        </router-link> -->
      </ul>
      <div class="login" @click="login" v-if="!isLogin">
        {{$t('登录')}}/{{$t('注册')}}
      </div>
      <div class="user-info flex-box" v-if="isLogin">
        <span class="people-icon"></span>
        <span>{{userName}}</span>
        <span class="cancle" @click="cancle"></span>
      </div>
      <div class="btn" @click="changelang">
        中/英
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-header',
  data () {
    return {
      lang: localStorage.getItem('lang') || 'zh'
    }
  },
  computed: {
    isLogin () {
      return localStorage.getItem('isLogin')
    },
    userName () {
      return localStorage.getItem('webOIUser')
    }
  },
  methods: {
    changelang () {
      this.lang = this.lang == 'zh' ? 'en' : 'zh'
      this.$i18n.locale = this.lang
      localStorage.setItem('lang', this.lang)
    },
    login () {
      this.$router.push('/login')
    },
    cancle () {
      localStorage.removeItem('webOIUser')
      localStorage.removeItem('isLogin')
      localStorage.removeItem('token')
      this.login()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  height: 87px;
  background: #304870;
  width: 100%;
  .people-icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    background: url('../assets/icon/people.png');
    background-size: 100% 100%;
    margin-right: 4px;
  }
  .cancle {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-left: 24px;
    cursor: pointer;
    background: url('../assets/icon/cancle.png');
    background-size: 100% 100%;
    margin-right: 30px;

  }
  .user-info {
    color: #fff;
    font-size: 16px;
  }
  .left {
    width: 600px;
    background: #4EABF9;
    padding-top: 24px;
    padding-bottom: 16px;
    padding-left: 60px;
    height: 87px;
    position: relative;
    box-sizing: border-box;
    &.mg-t16 {
      padding-top: 16px;
    }
    .logo {
      height: 40px;
      margin-right: 12px;
      display: inherit;
      border-radius: 50%;
    }
    .logo-text {
      font-size: 24px;
      font-weight: 500;
      color: #fff;
    }
    .text {
      color: #FFFFFF;
      font-size: 16px;
    }
    .logo-arrow {
      position: absolute;
      border: 87px solid transparent;
      border-top-color: #304870;
      top: 0;
      right: -87px;
    }
  }
  .btn {
    background: #4EABF9;
    border-radius: 4px;
    width: 70px;
    height: 33px;
    color: #fff;
    text-align: center;
    line-height: 33px;
    font-size: 14px;
    margin-right: 30px;
    cursor: pointer;
  }
  .herf-item {
    margin-right: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    &:hover {
      color: #73BFFF;
    }
  }
  .login {
    margin-right: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    &:hover {
      color: #73BFFF;
    }
  }
  .router-link-exact-active {
    color: #73BFFF;
  }
  a {
    text-decoration: none;
  }
}
</style>
